export class PasswordReset {
    public EmailAddress: String = '';
}



// WEBPACK FOOTER //
// ./src/app/models/password-reset.ts